<div class="space-y-4 p-4">
    <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-center space-x-4 mb-6">
            <div class="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center">
                <i class="pi pi-user text-white text-2xl"></i>
            </div>
            <div>
                <h2 class="text-xl font-bold text-gray-800">{{userProfile.onboarding?.fullName}}</h2>
                <p class="text-gray-600 text-sm">Phone Number: {{userProfile.phoneNumber}}</p>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-4 mb-6">
            <div class="text-center">
                <div class="text-2xl font-bold text-green-600">{{completedBatchesCount}}</div>
                <div class="text-sm text-gray-600">Batches Completed</div>
            </div>
            <div class="text-center">
                <div class="text-2xl font-bold text-blue-600">{{userProfile.rating?.toFixed(1) || 'N/A'}}</div>
                <div class="text-sm text-gray-600">Rating</div>
            </div>
        </div>
    </div>

    <div class="bg-white rounded-lg p-6 shadow-sm">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">Account Settings</h3>
        <div class="space-y-3">
            <button (click)="navigateToPersonalInformation()"
                class="w-full text-left py-3 px-4 rounded-lg hover:bg-gray-50 flex justify-between items-center">
                <span class="text-gray-700">Profile</span>
                <i class="pi pi-chevron-right text-gray-400"></i>
            </button>
            <button class="w-full text-left py-3 px-4 rounded-lg hover:bg-gray-50 flex justify-between items-center">
                <div>
                    <div class="text-gray-700">Bank Account <span class="text-orange-500 text-sm">(Coming Soon)</span></div>
                    <div class="text-gray-500 text-sm">
                        <span class="font-light">To receive your earnings, please add your bank account.</span>
                    </div>
                </div>
                <i class="pi pi-chevron-right text-gray-400"></i>
            </button>
            <button class="w-full text-left py-3 px-4 rounded-lg hover:bg-gray-50 flex justify-between items-center">
                <div>
                    <div class="text-gray-700">Shopper Card <span class="text-orange-500 text-sm">(Coming Soon)</span></div>
                    <div class="text-gray-500 text-sm">
                        <span class="font-light">Add to your wallet to pay in stores</span>
                    </div>
                </div>
                <i class="pi pi-chevron-right text-gray-400"></i>
            </button>
            <!-- <button class="w-full text-left py-3 px-4 rounded-lg hover:bg-gray-50 flex justify-between items-center">
                <span class="text-gray-700">Notifications</span>
                <i class="pi pi-chevron-right text-gray-400"></i>
            </button> -->
            <!-- <button class="w-full text-left py-3 px-4 rounded-lg hover:bg-gray-50 flex justify-between items-center">
                <span class="text-gray-700">Privacy & Security</span>
                <i class="pi pi-chevron-right text-gray-400"></i>
            </button> -->
        </div>
    </div>

    <div class="bg-white rounded-lg p-6 shadow-sm">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">Support</h3>
        <div class="space-y-3">
            <button (click)="navigateToHowToSucceed()"
                class="w-full text-left py-3 px-4 rounded-lg hover:bg-gray-50 flex justify-between items-center">
                <span class="text-gray-700">How To Succeed As A Shopper</span>
                <i class="pi pi-chevron-right text-gray-400"></i>
            </button>
            <button (click)="navigateToContactSupport()"
                class="w-full text-left py-3 px-4 rounded-lg hover:bg-gray-50 flex justify-between items-center">
                <span class="text-gray-700">Contact Support</span>
                <i class="pi pi-chevron-right text-gray-400"></i>
            </button>
        </div>
    </div>

    <div class="bg-white rounded-lg p-6 shadow-sm">
        <button (click)="logout()"
            class="logout-button w-full text-left py-3 px-4 rounded-lg hover:bg-red-50 flex justify-between items-center text-red-600 transition-colors duration-200">
            <span class="font-medium">Logout</span>
            <i class="pi pi-sign-out text-red-500"></i>
        </button>
    </div>

    <div class="bg-white rounded-lg p-6 shadow-sm">
        <button (click)="deleteAccount()"
            class="logout-button w-full text-left py-3 px-4 rounded-lg hover:bg-red-50 flex justify-between items-center text-red-600 transition-colors duration-200">
            <span class="font-medium">Delete Account</span>
            <i class="pi pi-trash text-red-500"></i>
        </button>
    </div>
</div>